import { useEffect } from 'react'
import { useBreadCrumbs } from './useBreadCrumbs'

const contextMenuConfig = [
  {
    label: 'Главная',
    url: `/`,
  },
]

export const useSetBreadCrumbsCurrentPath = (title: string) => {
  const { setBreadCrumbs } = useBreadCrumbs()

  useEffect(() => {
    setBreadCrumbs?.(title, contextMenuConfig)
  }, [title, setBreadCrumbs])
}
